import React from 'react';
import PropTypes from 'prop-types';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import RelatedStores from 'core/modules/RelatedStores/RelatedStores';
import MultipleMerchantsList from '../../MultipleMerchantsList/MultipleMerchantsList';
import SearchProductsLink from '../../SearchProductsLink/SearchProductsLink';
import MerchantPageTitle from '../../MerchantPageTitle/MerchantPageTitle';

import { MERCHANT_EXPERIENCE_TYPE_MULTIPLE } from '../../../actions/types';

function MerchantExperienceViewMultiple({
  merchants, config, keywords, gspConfig,
}) {
  const { sid } = config || {};
  const ids = merchants.map(({ id }) => id);

  return (
    <div
      className="mn_multiResults"
      data-test="merchant-experience-multiple"
      data-page-type={MERCHANT_EXPERIENCE_TYPE_MULTIPLE}
    >
      <ContentWrap>
        <div className="mn_multiResultsPageHeader">
          <MerchantPageTitle merchants={merchants} config={config} keywords={keywords} />
          {sid && <SearchProductsLink sid={sid} />}
        </div>
        <MultipleMerchantsList merchants={merchants} config={config} />
        {gspConfig && !gspConfig.isEnabled && <RelatedStores merchantIds={ids} />}
      </ContentWrap>
    </div>
  );
}

MerchantExperienceViewMultiple.propTypes = {
  merchants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  config: PropTypes.shape({}),
  keywords: PropTypes.string,
  gspConfig: PropTypes.shape({}),
};

MerchantExperienceViewMultiple.defaultProps = {
  config: {},
  keywords: null,
  gspConfig: {},
};

export default (props) =>
  <ComponentErrorBoundary><MerchantExperienceViewMultiple {...props} /></ComponentErrorBoundary>;
